import AppSidebar from "@/layouts/App/NavDrawer";
import AppToolbar from "@/layouts/App/Toolbar";
import AppFooter from "@/layouts/App/Footer";

import BlankPage from "@/views/BlankPage";
import BlankPage2 from "@/views/BlankPage2";



import ManageDealers from "@/views/ManageDealers";
import ManageGraders from "@/views/ManageGraders";
import GraderHome from "@/views/GraderHome";
import ManageGroups from "@/views/ManageGroups";
import ManageUsers from "@/views/ManageUsers";
import ManageQuestions from "@/views/ManageQuestions";
// import GradeISM from "@/views/gradeISM";
import GradeISM from "@/views/Curricula/GradeLead";

// import GradeCoachUp from "@/views/Curricula/GradeCoachUp";
import GradeCoachUp from "@/views/Curricula/GradeCoachUpContainer";

import GradeReport from "@/views/GradeReport";
import ReportCard from "@/views/ReportCard";
import CoachupReportCard from "@/views/CoachupReportCard";
import CoachupQue from "@/views/CoachupQue";
import CoachupRanking from "@/views/CoachupRanking";

import AdminHome from "@/views/AdminHome";


import AuthCallback from "@/views/auth-callback";
import ErrorUnauthorized from "@/views/ErrorUnauthorized";
import HomeRedirect from "@/views/HomeRedirect";
import AppOffLine from "@/views/AppOffLine"


// import ViewGrade from "@/components/viewGrade";
import ViewGradedLead from "@/views/ViewGradedLead";
import viewCoachup from "@/views/ViewCoachUp";
import ViewCoachUpPrint from "@/views/ViewCoachUpPrint";
import DownloadFile from "@/views/downloadFile";

import Analytics from "@/views/Analytics";



export const routes = [
   // {
   //    path: "/", redirect: "/grade-report"
   // },

   {
      path: "/",
      name: "HomeRedirect",
      component: HomeRedirect,

   },
   {
      path: "/error-unauthorized",
      name: "ErrorUnauthorized",
      component: ErrorUnauthorized
   },
   {
      path: "/offline",
      name: "AppOffLine",
      component: AppOffLine
   },
   {
      path: "/auth-callback",
      name: "auth-callback",
      component: AuthCallback
   },
   {
      path: "/blank-page",
      name: "BlankPage",
      components: {
         default: BlankPage,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/blank-page2",
      name: "BlankPage2",
      components: {
         default: BlankPage2,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/manage-graders",
      name: "ManageGraders",
      components: {
         default: ManageGraders,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      },
      auth:{
         acct_types: ['AGENCY'],
         role_types: ['Admin']
      }
   },
   {
      path: "/grader-home",
      name: "GraderHome",
      components: {
         default: GraderHome,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/manage-dealers",
      name: "ManageDealers",
      components: {
         default: ManageDealers,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/manage-dealer-groups",
      name: "ManageGroups",
      components: {
         default: ManageGroups,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/manage-users",
      name: "ManageUsers",
      components: {
         default: ManageUsers,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/manage-questions",
      name: "ManageQuestions",
      components: {
         default: ManageQuestions,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },

   {
      path: "/grade-ism",
      name: "GradeISM",
      components: {
         default: GradeISM,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/grade-report",
      name: "GradeReport",
      components: {
         default: GradeReport,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },
   {
      path: "/coachup",
      name: "GradeCoachUp",
      components: {
         default: GradeCoachUp,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },

   {
      path: "/coachup-que",
      name: "CoachupQue",
      components: {
         default: CoachupQue,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      },
      auth:{
         acct_types: ['AGENCY', 'CLIENT'],
         role_types: ['Admin', 'Executive', 'Manager']
      }
   },


   {
      path: "/coachup-ranking",
      name: "CoachupRanking",
      components: {
         default: CoachupRanking,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      },
      auth:{
         acct_types: ['AGENCY', 'CLIENT'],
         role_types: ['Admin', 'Executive', 'Manager']
      }

   },


   {
      path: "/report-cards",
      name: "ReportCard",
      components: {
         default: ReportCard,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },


   {
      path: "/coachup-report-cards",
      name: "CoachupReportCard",
      components: {
         default: CoachupReportCard,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },

   {
      path: "/view-grade/:grade_id",
      name: "ViewGradedLead",
      components: {
         default: ViewGradedLead,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },

   {
      path: "/view-coachup/:coachup_id",
      name: "viewCoachUp",
      components: {
         default: viewCoachup,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },

   {
      path: "/view-coachup-print/:coachup_id",
      name: "viewCoachUpPrint",
      components: {
         default: ViewCoachUpPrint,
      }
   },

   {
      path: "/download-file/:grade_id",
      name: "DownloadFile",
      components: {
         default: DownloadFile,
         // sidebar: AppSidebar,
         // header: AppToolbar,
         // footer: AppFooter
      }
   },

   {
      path: "/home-admin/",
      name: "AdminHome",
      components: {
         default: AdminHome,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },


   {
      path: "/analytics",
      name: "Analytics",
      components: {
         default: Analytics,
         sidebar: AppSidebar,
         header: AppToolbar,
         footer: AppFooter
      }
   },




   // {
  //   path: "/login",
  //   name: "Login",
  //   meta: { layout: "auth" },
  //   components: {
  //     default: Login
  //   }
  // },
  //  {
  //     path: "/test-auth",
  //     name: "test-auth",
  //     meta: { layout: "auth" },
  //     components: {
  //        default: test_auth
  //     }
  //  }
];

// components: { default: LoginPage },
// name: "pages/authentication/LoginPage",
//    meta: { layout: "auth" }
